export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5622.683406b3.jpg";